import React from 'react';
import ServicePropThree from '../service/ServicePropThree';
import SEOAchievementsData from "../../data/seo/SEOAchievements.json"


const SEOAchievements = () => {
    return (
        <div className="section section-padding relative" style={{ overflow: 'hidden' }}>
            <div style={{
                background: "linear-gradient(to bottom, #F2F2FF, #FFFFFF)",
                position: 'relative',
                zIndex: 1
            }}>
                <div className="container">
                    <div className="section-heading heading-center mb--40">
                        <div className="text-center mb-5">
                            <p className="text-danger mb-2">What You’ll Achieve </p>
                            <h2 className="display-4 fw-bold">Your Achievements With Us</h2>
                        </div>
                    </div>
                    <div className="row g-4" style={{ paddingBottom: '60px' }}>
                        <ServicePropThree
                            colSize="col-lg-3 col-md-12"
                            serviceStyle="service-style-3 seo-achievements-card"
                            serviceData={SEOAchievementsData}
                        />
                    </div>
                </div>
            </div>

            {/* Full width SVG positioned absolutely */}
            <svg
                width="100%"
                height={275}
                viewBox="0 0 1920 275"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="SMM-section-curve-line"
                preserveAspectRatio="none"
            >
                <mask
                    id="mask0_24_38"
                    style={{
                        maskType: "luminance",
                    }}
                    maskUnits="userSpaceOnUse"
                    x={0}
                    y={0}
                    width={1920}
                    height={275}
                >
                    <path
                        d="M0 6.23198C318.332 274.567 688.226 -17.9956 1033.19 0.884379C1245.07 12.478 1640.23 164.457 1920 129.262V274.567H0C0 185.122 0 95.6773 0 6.23198Z"
                        fill="white"
                    />
                </mask>
                <g mask="url(#mask0_24_38)">
                    <path d="M1920 -18H0V274.563H1920V-18Z" fill="#F2F2FF" />
                </g>
            </svg>

            <style jsx>{`
                .smm-feature-card {
                    padding: 40px 0;
                    border-radius: 10px;
                    height: 100%;
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                }

                .seo-achievements-card {
                    padding: 20px !important;
                    min-height: 100% !important;
                    margin-bottom: 0 !important;
                    border-radius: 15px !important;
                }

                .seo-achievements-card .title {
                    font-size: 20px !important;
                    margin-top: 10px !important;
                    }
                    
                    .seo-achievements-card p {
                        color: black !important;
                        margin-top: 5px !important;
                        font-size: 14px !important;
                        }

                .SMM-section-curve-line {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    width: 100vw;
                    height: auto;
                    top:0;
                    z-index: 0;
                    margin-left: calc(-50vw + 50%);
                }

                @media (max-width: 991px) {
                    .row.g-4 {
                        padding-bottom: 80px !important;
                    }
                    .connector-line {
                        display: none;
                    }
                }

                @media (max-width: 767px) {
                    .row.g-4 {
                        padding-bottom: 100px !important;
                    }
                }

                @media (max-width: 575px) {
                    .row.g-4 {
                        padding-bottom: 60px !important;
                    }
                    .smm-feature-card {
                        padding: 0;
                    }
                }

                .animate-fade-in {
                    animation: fadeInUp 0.6s ease-out;
                }

                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
        </div>
    );
};

export default SEOAchievements;